import angular from 'angular';
import _ from 'lodash-es';
import APIV5 from '~/models/api';
import Utils from '~/scripts/services/utils';
import Defaults from '~/scripts/constants/defaults';
import { BaseController } from '~/utils/base-controller';
import { Breakpoints, MD_AND_DOWN } from '~/services/breakpoints.service';

/* globals Search */

export default class SearchBarController extends BaseController {
	/* @ngInject */
	/**
	 * @param {any} NodeService
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').route.IRouteService} $route
	 * @param {any} $scope
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor(
		NodeService,
		$element,
		$route,
		$scope,
		$injector,
	) {
		super($injector);

		this.NodeService = NodeService;
		this.$element = $element;
		this.$route = $route;
		this.$scope = $scope;

		/** @type {any[]} */
		this.cacheDefaultSearch = [];
		this.date = undefined;
		this.datePickerOptions = {
			allowInput:      false,
			dateFormat:      'Y-m-d',
			displayInput:    false,
		};
		this.display = 'list';
		this.exporting = false;
		this.filterEnabled = undefined;
		this.filterEnabledOptions = {
			active: {
				name: 'common.active',
				icon: 'check-circle',
				style: 'success',
				value: true,
			},
			inactive: {
				name: 'common.inactive',
				icon: 'times-circle',
				style: 'danger',
				value: false,
			},
			all: {
				name: 'common.all',
				icon: 'circle',
				style: 'muted',
				value: null,
			},
		};
		this.hasCreatePermissions = false;
		this.isCollapsed = true;
		this.isShortcuts = false;
		this.ready = false;
		this.list = [];
		this.months = [];

		/** @type {any} */
		this.mfTypeDocOptions = {
			/** @type {boolean} */
			icon:                false,

			/** @type {string | undefined} */
			name:                undefined,

			/** @type {boolean} */
			uniqueKid:           true,

			/** @type {boolean} */
			displayExpandButton: false,
		};
		this.mfTypeDocParams = {
			mf_order:   'CLASS',
			mf_suggest: '',
		};

		this.mfTypeDocWidth = 50;

		this.options = {
			advanced:           false,
			tooltipTypeDocOpen: false,
		};

		// Generate month names
		for (const [k, m] of [
			'K_NODE;JANUARY',
			'K_NODE;FEBRUARY',
			'K_NODE;MARCH',
			'K_NODE;APRIL',
			'K_NODE;MAY',
			'K_NODE;JUNE',
			'K_NODE;JULY',
			'K_NODE;AUGUST',
			'K_NODE;SEPTEMBER',
			'K_NODE;OCTOBER',
			'K_NODE;NOVEMBER',
			'K_NODE;DECEMBER',
		].entries()) {
			const date = new Date(`${k + 1}`).toLocaleString('fr', { month: 'long' });
			this.months.push({
				// @ts-ignore
				name: Utils.ucfirst(date),
				kid: m,
			});
		}

		this.searchContextMenu = [
			{
				text: '<i class="fa fa-refresh"></i> <span class="context-menu-text">Rafraichir la liste</span>',
				click: () => {
					this.$rootScope.$broadcast('List.search', true);
				},
			},
		];
	}

	/**
	 * @param {string} query
	 */
	createClass(query) {
		this.$location.url(`/form/K_NODE;SYS_CLASSE/create?repre=${query}`);
	}

	deleteFilter() {
		this.$timeout(() => {
			this.$element.find('.form-group-filters > mf input.form-control').trigger('focus');
		});
	}

	deleteNode() {
		this.Search.type = undefined;
	}

	expandSearchBar() {
		if (this.isShortcuts) {
			this.isCollapsed = false;
		}
	}

	/**
	 * @param {MouseEvent} event
	 */
	exportXLSX(event) {
		if (event?.target) {
			angular.element(event.target).closest('.btn').trigger('blur');
		}
		this.$rootScope.$broadcast('List.onExportXLSX');
		this.exporting = true;
	}

	/**
	 * @param {?MouseEvent} event
	 */
	async search(event) {
		if (event?.target) {
			angular.element(event.target).closest('.btn').trigger('blur');
		}
		this.options.advanced = Utils.isMobile() ? false : this.Search.filters.length > 0;

		const parameterFilters = this.Search.filters.length > 0 ? { filter: angular.toJson(this.Search.filters) } : '';

		if (
			!_.isEqual(parameterFilters, this.$location.search().filter)
			|| this.$location.path() !== `/list/${this.Search.type?.kid}`
		) {
			this.$location.url(`/list/${this.Search.type?.kid}`).search(parameterFilters);
			this.$route.reload();
		}
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {MouseEvent} event
	 * @param {any} item
	 */
	selectFilter(event, item) {
		if (event?.target) {
			angular.element(event.target).val('');
			this.$timeout(async () => {
				if (!this.Search.type?.kid && item.kid) {
					this.selectNode({
						kid:  item.isa,
						name: item.isa_name,
					});
					await this.search(null);
				}
				else if (event?.target) {
					angular.element(event.target).trigger('focus');
				}
			});
		}
	}

	/**
		* @param {Search.Item} item
		*/
	async selectNode(item) {
		if (item) {
			this.Search.setItem(item);
			this.mfTypeDocOptions.name = item.name;
			this.hasCreatePermissions = item.kright !== undefined && (item.kright & Defaults.DROIT.CREATE) > 0;

			if (this.isShortcuts === true) {
				if (this.Search.suggestedTypes?.some(element => element.kid === item.kid)) {
					// If the selected element already exist in original this.Search.suggestedTypes, get filters
					if (this.Search.suggestedTypes.find(element => element.kid === item.kid).filters === null) {
						const filters = await APIV5.instance.searchFilters(
							{ nodeid: item.kid },
							{ id: 'search-bar.select-node' },
						);
						if (filters.result.length > 0) {
							this.$timeout(() => {
								this.Search.suggestedFilters = [...filters.result];
							});
						}
					}
					else {
						this.Search.suggestedFilters = this.Search.suggestedTypes.find(element => element.kid === item.kid).filters;
					}
				}
				else if (this.cacheDefaultSearch.some(element => element.kid === item.kid)) {
					// If the selected element already exist in "cache", get filters
					this.Search.suggestedFilters = this.cacheDefaultSearch.find(element => element.kid === item.kid).filters;
				}
				else {
					// If the selected element dont exist, call searchFilters & save into filterlist
					this.$q
						.when(APIV5.instance.searchFilters({
							nodeid: item.kid,
						}, { id: 'search-bar.select-node' }))
						.then(filters => {
							_.merge(item, { filters: filters.result });
							this.cacheDefaultSearch.push(item);
							this.Search.suggestedFilters = filters.result;
							return true;
						})
						.catch(() => {
							if (this.Search.suggestedFilters) {
								this.Search.suggestedFilters.length = 0;
							}
						});
				}
			}
		}
	}

	/**
		*
		* @param {*} event
		* @param {Search.Item} item
		*/
	async selectTypeDoc(event, item) {
		event.preventDefault();
		if (Array.isArray(item.filters)) {
			this.Search.suggestedFilters = [...item.filters];
		}
		else if (item.filters === null) {
			const filters = await APIV5.instance.searchFilters(
				{ nodeid: item.kid },
				{ id: 'search-bar.select-type-doc' },
			);
			if (filters.result.length > 0) {
				this.$timeout(() => {
					item.filters = filters.result;
					this.Search.suggestedFilters = [...item.filters];
				});
			}
		}
		this.Search.setItem(item);
		this.mfTypeDocOptions.name = item.name;
		this.hasCreatePermissions = item.kright !== undefined && (item.kright & Defaults.DROIT.CREATE) > 0;
	}

	/**
	 * @param {string} display
	 */
	setDisplay(display) {
		this.display = display;
		this.$rootScope.$broadcast('List.setDisplay', display);
	}

	/**
	 * @param {'active' | 'inactive' | 'all'} value
	 */
	setFilterEnabled(value) {
		this.filterEnabled = this.filterEnabledOptions[value];
		this.Search.enabled = this.filterEnabled.value;
	}

	updateDate() {
		if (typeof this.date === 'string') {
			this.date = new Date(this.date);
		}

		if (this.date instanceof Date) {
			if (this.Search.filters.some((/** @type {any} */ element) => element.isa === 'K_NODE;MONTHDAY')) {
				// edit day
				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTHDAY').name
					= this.date.getDate();

				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTHDAY').isa_name
					// @ts-ignore
					= Utils.ucfirst(this.$translate.instant('common.day'));

				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTHDAY').kid
					= `K_NODE;MD${this.date.getDate()}`;
			}
			else {
				// add day
				this.Search.filters.splice(0, 0, {
					kid:  `K_NODE;MD${this.date.getDate()}`,
					name: this.date.getDate(),
					isa:  'K_NODE;MONTHDAY',
					isa_name: this.$translate.instant('common.day'),
				});
			}
			if (this.Search.filters.some((/** @type {any} */ element) => element.isa === 'K_NODE;MONTH')) {
				// edit month
				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTH').name
					= this.months[this.date.getMonth()].name;

				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTH').isa_name
					// @ts-ignore
					= Utils.ucfirst(this.$translate.instant('common.month'));

				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;MONTH').kid
					= this.months[this.date.getMonth()].kid;
			}
			else {
				// add month
				this.Search.filters.splice(1, 0, {
					kid:  this.months[this.date.getMonth()].kid,
					name: this.months[this.date.getMonth()].name,
					isa:  'K_NODE;MONTH',
					isa_name: this.$translate.instant('common.month'),
				});
			}
			if (this.Search.filters.some((/** @type {any} */element) => element.isa === 'K_NODE;YEAR')) {
				// edit year
				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;YEAR').name
					= this.date.getFullYear();

				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;YEAR').isa_name
					// @ts-ignore
					= Utils.ucfirst(this.$translate.instant('common.year'));
				this.Search.filters.find((/** @type {any} */ filter) => filter.isa === 'K_NODE;YEAR').kid
					= `K_NODE;Y${this.date.getFullYear()}`;
			}
			else {
				// add year
				this.Search.filters.splice(2, 0, {
					kid:  `K_NODE;Y${this.date.getFullYear()}`,
					name: this.date.getFullYear(),
					// @ts-ignore
					isa_name: Utils.ucfirst(this.$translate.instant('common.year')),
					isa:  'K_NODE;YEAR',
				});
			}
		}
	}

	init() {
		const isSearch = this.$location.path().startsWith('/list/');

		let chain = this.$q.resolve();
		let item = this.Search.getItem();
		this.$timeout(async () => {
			if (item) {
				if (item.kid && !item.kright) {
					item = await this.NodeService.load(item.kid);
				}
				if (item) {
					this.hasCreatePermissions = item.kright !== undefined && (item.kright & Defaults.DROIT.CREATE) > 0;
				}
			}
		});

		// If search bar is on /list/ route && it have a kid
		// If the page is reloaded, the kid is not already inside the Search cache
		if (isSearch && /^K_NODE;.+$/.test(this.$routeParams.kid) && !item?.kid) {
			// Emulate an mf selection
			// @ts-ignore
			chain = chain
				.then(() => this.Search.setFromKid(this.$routeParams.kid))
				.then(() => {
					if (item) {
						this.hasCreatePermissions = item.kright !== undefined && (item.kright & Defaults.DROIT.CREATE) > 0;
					}
					// If there are filters, parse them
					if (this.$location.search().filter) {
						let filters = [];
						try {
							filters = JSON.parse(this.$location.search().filter);
						}
						catch {
							console.error('Unable to parse filters');
						}
						this.Search.setFilters(filters);
					}

					return true;
				});
		}

		const isMobile = Breakpoints.is(MD_AND_DOWN);
		if (isMobile && !isSearch) {
			this.isCollapsed = false;
		}

		chain
			.then(() => {
				let infos = this.$q.resolve({
					result: this.Search.suggestedTypes,
					default_search: this.Search.defaultSearch,
				});

				// Fetch searchInfos if not already
				if (this.Search.suggestedTypes.length === 0) {
					infos = this.$q.when(APIV5.instance.searchInfo({ id: 'searchbar-init' }));
				}

				return infos;
			})
			// @ts-ignore
			.then(searchinfo => {
				this.Search.suggestedTypes = searchinfo.result;
				this.isShortcuts = this.Search.suggestedTypes.length > 0;
				this.ready = true;
				this.Search.defaultSearch = searchinfo.default_search;
				this.hasCreatePermissions = (searchinfo.default_search.kright & Defaults.DROIT.CREATE) > 0;
				this.mfTypeDocParams.mf_order = searchinfo.default_search.mf_order;
				this.mfTypeDocParams.mf_suggest = searchinfo.default_search.mf_suggest;

				if (!this.Search.type) {
					if (this.Search.defaultSearch.kid === '0') {
						this.Search.reset();
					}
					else {
						this.Search.setItem(this.Search.defaultSearch);
						this.hasCreatePermissions = (this.Search.defaultSearch?.kright & Defaults.DROIT.CREATE) > 0;

						const findSuggestion = this.Search.suggestedTypes?.find(x => x.kid === this.Search.type?.kid);
						if (findSuggestion) {
							this.Search.suggestedFilters = findSuggestion.filters === null ? [] : [...findSuggestion.filters];
						}
					}
					this.mfTypeDocOptions.name = this.Search.defaultSearch?.name;
				}

				return this.Search.suggestedTypes.length === 0
					? APIV5.instance.searchFilters(
						{ nodeid: this.Search.defaultSearch.kid },
						{ id: 'search-bar.init' },
					)
					: this.$q.resolve({ result: [] });
			})
			.then(filters => {
				if (filters.result.length > 0) {
					this.Search.suggestedFilters = filters.result;
				}
				return true;
			})
			.then(() => {
				this.$scope.$emit('Search.onReady');
				return true;
			})
			.catch(error => {
				console.error(error);
				this.ready = true;
				this.Search.suggestedTypes = [];
				this.isShortcuts = false;
				this.Search.reset();
			});
	}

	$onInit() {
		this.$rootScope.$on('User.login', () => {
			this.init();
		});

		if (this.Search.enabled === true) {
			this.filterEnabled = this.filterEnabledOptions.active;
		}
		else if (this.Search.enabled === false) {
			this.filterEnabled = this.filterEnabledOptions.inactive;
		}
		else {
			this.filterEnabled = this.filterEnabledOptions.all;
		}

		const theme = this.$rootScope.appConfig?.theme;
		if (theme?.searchBar?.mfTypeDoc?.percentWidth) {
			this.mfTypeDocWidth = theme.searchBar.mfTypeDoc.percentWidth;
		}

		this.$scope.$on('User.logout', () => {
			this.Search.reset();
			this.mfTypeDocOptions.name = undefined;
			this.date = undefined;
		});

		this.$scope.$on('Search.onSetFilters', () => {
			this.options.tooltipTypeDocOpen = false;
		});

		// @ts-ignore
		this.$rootScope.$on('Search.onLaunchSearch', event => this.search(event));

		this.$rootScope.$on('List.exportedXLSX', () => {
			this.exporting = false;
		});

		if (this.$rootScope.context?.token?.id) {
			this.init();
		}
	}
}
